import React, { useState, useContext, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Pdf from 'react-to-pdf';
import CartCtx from '../CartCtx';
import logo from '../../img/logo-new.svg';
// import logo from '../../img/logo.svg';
import { getFormatterCount } from '../cart/utils';

const CheckoutCompleteModal = ({
    num,
    cName,
    cPhone,
    cEmail,
    cAddress,
    del,
    paym,
    comment,
    companyName,
    companyInn,
    products = [],          // список из getProducts()
    pickupTcName = '',      // название ТЦ самовывоза
    totalSumm = 0,
}) => {
    const context = useContext(CartCtx);
    const [showCart, setShowCart] = useState(true);
    const pdfRef = useRef(null);

    const handleClose = () => {
        setShowCart(false);
        context.clearCart();
    };

    const onPdfComplete = () => {
        //this.context.clearCart()
    };

    const getDeliveryText = () => {
        if (del === '1') {
            return (
                <b>
                    {' '}
                    Самовывоз из магазина
                    {pickupTcName ? ` (${pickupTcName})` : ''}
                </b>
            );
        }

        if (del === '99') {
            return (
                <b>
                    {' '}
                    Доставка
                    <br />
                    Адрес: {cAddress}
                </b>
            );
        }

        return null;
    };

    const getPaymentText = () => {
        if (paym === '1') return <b> Наличный расчёт</b>;
        if (paym === '2') return <b> Безналичный расчёт</b>;
        return null;
    };

    // высота PDF
    const pdfHeight = Math.max(900, 300 + 50 * products.length);

    return (
        <>
            <Modal
                show={showCart}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName="modal-checkout__complete"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ваш заказ принят!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text">
                        <h5>Благодарим!</h5>
                        <h5>Ваш заказ отправлен в обработку.</h5>
                        <p>
                            Номер заказа: <b>{num}</b>
                        </p>
                        <span>В ближайшее время с Вами свяжется наш менеджер</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Pdf
                        targetRef={pdfRef}
                        filename={`order-${num}.pdf`}
                        onComplete={onPdfComplete}
                        options={{
                            format: [600.0, pdfHeight],
                        }}
                    >
                        {({ toPdf }) => (
                            <Button variant="light" onClick={toPdf}>
                                Сохранить заказ в PDF <i className="i-pdf" />
                            </Button>
                        )}
                    </Pdf>

                    <Link to="/" className="btn btn-primary" onClick={handleClose}>
                        Вернуться на главную
                    </Link>
                </Modal.Footer>
            </Modal>

            {/* Скрытый блок для генерации PDF */}
            <div
                ref={pdfRef}
                className="modal-cart__wrap"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: -750,
                    zIndex: -1,
                    width: '750px',
                    minHeight: '2000px',
                    background: '#ffffff',
                }}
            >
                <div className="pdf-view">
                    <header>
                        <img src={logo} alt="Логотип" />
                        <p>Детали заказа</p>
                    </header>

                    <section className="customer-info">
                        <p>
                            ЗкС-№: <b>{num}</b>
                        </p>
                        <p>
                            Имя покупателя: <b>{cName}</b>
                        </p>
                        <p>
                            Тел. покупателя: <b>{cPhone}</b>
                        </p>
                        <p>
                            Email покупателя: <b>{cEmail}</b>
                        </p>

                        {/* {companyName && (
                            <p>
                                Название компании: <b>{companyName}</b>
                            </p>
                        )}
                        {companyInn && (
                            <p>
                                Код ЕГРПОУ: <b>{companyInn}</b>
                            </p>
                        )} */}

                        <p>
                            Способ доставки:
                            {getDeliveryText()}
                        </p>

                        <p>
                            Способ оплаты:
                            {getPaymentText()}
                        </p>

                        {comment && (
                            <p>
                                Комментарий к заказу: <b>{comment}</b>
                            </p>
                        )}
                    </section>

                    <hr />
                    <h4>Состав заказа</h4>

                    <section className="customer-items">
                        <div className="cart-items">
                            <table className="cart-table">
                                <thead className="cart-table__header">
                                    <tr>
                                        <th className="col-num">№</th>
                                        <th>Артикул</th>
                                        <th>Название</th>
                                        <th>Цена</th>
                                        <th>Кол-во</th>
                                        <th>Сумма</th>
                                    </tr>
                                </thead>
                                <tbody className="cart-table__body">
                                    {products.map((product, index) => {
                                        const priceData = product?.tc?.find(
                                            (t) => t.id == context.selectedCenter?.id
                                        )?.priceBadgeStock?.price;

                                        const unitPrice = priceData?.discountPrice
                                            ? priceData.discountPrice
                                            : priceData?.price;

                                        const count = product.count_cart || 1;
                                        const step = product.step || 1;
                                        const lineTotal = unitPrice ? (unitPrice * count * step) : 0;

                                        return (
                                            <tr key={product.id || index}>
                                                <td className="col-num">{index + 1}</td>
                                                <td className="col-articule">{product.articule}</td>
                                                <td className="col-name">{product.name}</td>
                                                <td className="col-price i-rub">
                                                    {
                                                        unitPrice != null
                                                            ?
                                                            Number(unitPrice).toLocaleString('ru')
                                                            : '—'
                                                    }
                                                </td>
                                                <td className="col-qty">{getFormatterCount(count, product?.step)}  {product.unit ? `/${product.unit}` : ''}</td>
                                                <td className="col-total i-rub">
                                                    {lineTotal
                                                        ? Number(lineTotal).toLocaleString('ru')
                                                        : '—'}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="cart-footer">
                            <div className="cart-footer__left" />
                            <div className="cart-footer__right">
                                <div className="cart-total">
                                    <p>Всего:</p>
                                    <span className="i-rub">
                                        {Number(totalSumm).toLocaleString('ru')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default CheckoutCompleteModal;